import { Link } from "react-router-dom";
import { BookOpen, Lightbulb, FileText, ShieldCheck, ArrowRight } from "lucide-react";
import {
  Container,
  Section,
  Heading,
  Lede,
  Eyebrow,
  Card,
} from "../components/ui";
import { useSeo } from "../lib/seo";

const TILES = [
  { icon: BookOpen, title: "Blog", body: "Product updates, regulatory commentary, clinical deep-dives.", to: "/blog" },
  { icon: FileText, title: "Docs", body: "Implementation guides and API references.", to: "/docs" },
  { icon: ShieldCheck, title: "Trust center", body: "Security, HIPAA, BAA, DPA, subprocessors, and SLA.", to: "/trust" },
  { icon: Lightbulb, title: "Press kit", body: "Logo lockups, color palette, brand guidelines.", to: "/press" },
];

export function Resources() {
  useSeo({
    title: "Resources — WeConsult Rx",
    description:
      "Resource hub for consultant pharmacists: blog, docs, trust center, and press kit.",
    path: "/resources",
  });
  return (
    <Section>
      <Container>
        <div className="max-w-3xl">
          <Eyebrow>Resources</Eyebrow>
          <Heading level={1} className="mt-3">
            Everything we know — at your disposal.
          </Heading>
          <Lede className="mt-6">
            Blog, docs, trust center, press kit. We share our work openly.
          </Lede>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-2">
          {TILES.map((t) => {
            const Icon = t.icon;
            return (
              <Card key={t.title}>
                <div className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-forest-50 text-forest-700">
                    <Icon className="h-5 w-5" aria-hidden />
                  </span>
                  <Heading level={3}>{t.title}</Heading>
                </div>
                <p className="mt-4 text-ink-600">{t.body}</p>
                <Link
                  to={t.to}
                  className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-forest-700 hover:text-forest-900"
                >
                  Explore {t.title}
                  <ArrowRight className="h-4 w-4" aria-hidden />
                </Link>
              </Card>
            );
          })}
        </div>
      </Container>
    </Section>
  );
}
